<script lang="ts">
	import ArrowUp from 'assets/svg/arrowUp.svg?component';
	import ArrowDown from 'assets/svg/arrowDown.svg?component';
	import { onDestroy, onMount } from 'svelte';
	import { browser } from '$app/environment';

	export let dark: boolean;
	export let variants: { name: string }[];
	export let selectedFilter: string;
	export let handleFilter: (filter: string) => void;

	let filterRef: HTMLElement;
	let isOpen = false;

	onMount(() => {
		document.addEventListener('click', handleClose);
	});

	onDestroy(() => {
		if (browser) {
			document.removeEventListener('click', handleClose);
		}
	});

	const handleClose = (e: Event) => {
		const target = e.target as HTMLElement;
		if (filterRef && !filterRef.contains(target)) {
			isOpen = false;
		}
	};
</script>

<div class="wrapper" bind:this={filterRef} class:dark>
	<!-- svelte-ignore a11y-click-events-have-key-events -->
	<!-- svelte-ignore a11y-no-static-element-interactions -->
	<div
		class="visible"
		on:click={() => {
			isOpen = !isOpen;
		}}
	>
		<p class="selected text">{selectedFilter.replaceAll('_', ' ')}</p>
		{#if isOpen}
			<ArrowUp class={`select-icon ${dark ? 'dark' : ''}`} width={8} height={8} />
		{:else}
			<ArrowDown class={`select-icon ${dark ? 'dark' : ''}`} width={8} height={8} />
		{/if}
	</div>

	<ul class="filter-list" class:open={isOpen}>
		{#each variants as filter}
			<li>
				<!-- svelte-ignore a11y-click-events-have-key-events -->
				<!-- svelte-ignore a11y-no-static-element-interactions -->
				<div
					class="filter-item text"
					on:click={() => {
						isOpen = !isOpen;
						handleFilter(filter.name.replaceAll(' ', '_'));
					}}
				>
					{filter.name}
				</div>
			</li>
		{/each}
	</ul>
</div>

<style lang="scss">
	@import 'filterSelect';
</style>
